<template>
	<div class="topSearch">
	  <div class="subTop1">
	    <em>Top Search</em>
	    <span>热搜推荐</span>
			<div style="display: inline-block;margin-top: 25px;float: right;cursor: pointer;" @click="showpage=!showpage">
				<i class="el-icon-refresh" style="font-size: 20px;"></i>
				换一换
			</div>
	  </div>
	  <ul v-if="showpage">
			<li v-for="(item,index) in resouList" v-if="index<5">
				<img :src="'/images/0'+(index+1)+'.png'"/>
				<a @click="jumppush('/detail/'+item.id)" :title="item.title">{{item.title}}</a>
			</li>
	    <!-- <li><img src="images/01.png"/><a href="##">中国网络文明大会这些亮点别错过</a></li>
	    <li><img src="images/02.png"/><a href="##">数据说话：中国经济稳定性何来？</a></li>
	    <li><img src="images/03.png"/><a href="##">中国高技术产业引资持续增长</a></li>
	    <li><img src="images/04.png"/><a href="##">2022世界数字经济大会今日启幕</a></li>
	    <li><img src="images/05.png"/><a href="##">数字藏品“炒”起潮落</a></li> -->
	  </ul>
		<ul  v-else>
			<li v-for="(item,index) in resouList" v-if="index>4&&index<10">
				<img :src="'/images/0'+(index+1)+'.png'"/>
				<a @click="jumppush('/detail/'+item.id)" :title="item.title">{{item.title}}</a>
			</li>
		</ul>
	</div>
</template>

<script>
	export default {
		data() {
			return {
				isloading:true,
				resouList: [],
				showpage:true,
			}
		},
		created: function() {
			this.resoufnc();
		},
		computed: {
	
		},
		methods: {
			showLogin: function() {
				this.$emit('showLogin');
			},
			jumppush:function(to){
				if(!this.$cookies.get('userinfo')){
					this.showLogin();
					return false;
				}
				else{
					var a = document.createElement('a');
					a.setAttribute('href', to);
					a.setAttribute('style', 'display:none');  
					a.setAttribute('target', '_blank');  
					document.body.appendChild(a);
					a.click();
					a.parentNode.removeChild(a); 
				}
			},
			resoufnc: function() {
				let _this = this;
				this.$http({
						method: 'get',
						url: 'szjj/searchArticles',
						responseType: 'json',
						params: {
							columnID: 'c8698d1b80724c1080de954bccdb51a5',
							// isTopArticle: '1',
							iPage:'1',
							pageSize:'10',
							// tagName:'评论',
						},
					})
					.then(function(response) {
						_this.resouList = response.data.data.data.data;
						_this.isloading=false;
					})
					.catch(function(error) {
						console.log(error);
						_this.isloading=false;
					});
			},
		}
	}
</script>

<style>
</style>
